export default function Label({ children }) {
  return <div className="auth__label">
    {children}
  </div>
}
